import React, { useState, useEffect, useCallback } from 'react'
import PropTypes from 'prop-types'
import { SelectInput } from '../Inputs/Inputs.jsx'

import styles from '../../../../css/devicePage.module.css'
import stylesSettings from '../../../../css/settings.module.css'

import AppDispatcher from '../../../dispatchers/AppDispatcher'

const DeviceGroup = ({ device, customer }) => {
  const [groupId, setGroupId] = useState(device.group_id)

  const appDispatch = useCallback(() => {
    const { id: deviceID } = device

    AppDispatcher.dispatch({
      action: 'change-device',
      deviceID,
      data: {
        group_id: groupId,
      },
    })
  }, [groupId, device])

  useEffect(() => {
    appDispatch()
  }, [groupId])

  const childChange = useCallback((event) => {
    console.log('DeviceGroup childChange', event.target.value)
    setGroupId(event.target.value)
  }, [])

  const {
    applications,
  } = customer || {}

  let groupOptions = []
  if (applications && Array.isArray(applications)) {
    groupOptions = applications.map((application) => {
      const {
        groupID: value,
        name,
      } = application

      if (typeof value === 'undefined') {
        return ({ value: '', name: 'None' })
      }

      return ({ value, name })
    })
  }

  return (
    <div>
      <section className={`${styles.simpleLink} ${styles.simpleLinkBorderPhysical}`}>
        <h5>
          Device Group
        </h5>
        <div className={styles.simpleLinkValueEdit}>
          <SelectInput
            value={groupId}
            childChange={childChange}
            field='group_id'
            options={groupOptions}
            style={stylesSettings.ruleSelectInput}
          />
        </div>
      </section>
    </div>
  )
}

DeviceGroup.propTypes = {
  device: PropTypes.object.isRequired,
  customer: PropTypes.object.isRequired,
}

export default DeviceGroup
